import moment, { Moment } from 'moment/moment'

export interface AdviceSectionPayload {
    id: number
    name: string
    published?: boolean
    sort_order: number
    created_at: string
    advices_count?: number
    translations?: {}
}

export class AdviceSection {

    id: number
    name: string
    published: boolean
    sortOrder: number
    createdAt: Moment
    advicesCount: number
    translations?: {} = <any>{}

    constructor(data: AdviceSectionPayload) {
        this.id = data.id
        this.name = data.name
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.advicesCount = data.advices_count || 0
        this.capture(data)
    }

    fill(data: AdviceSectionPayload): this {
        this.id = data.id
        this.name = data.name
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.advicesCount = data.advices_count || 0
        this.capture(data)
        return this
    }

    capture(data: AdviceSectionPayload): this {
        if (data.translations) {
            this.translations = data.translations
        }
        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<any>{})
        this.translations = {}
    }

    payload(): AdviceSectionPayload | any {
        return {
            id: this.id,
            name: this.name,
            published: this.published,
            sort_order: this.sortOrder,
            translations: this.translations,
        }
    }
}
